import React, { useEffect, useState } from "react";
import API from "../../utils/api";
import { createItemOnBoard } from "./monday";
import ConfirmActionModal from "../Shared/ConfirmActionModal";
const FlaggedReviewsTable = () => {
    const [flaggedReviews, setFlaggedReviews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [confirmationMessage, setConfirmationMessage] = useState("");


    useEffect(() => {
        fetchFlaggedReviews();
    }, []);

    const fetchFlaggedReviews = async () => {
        try {
            const res = await API.get("/reviews/flaggedAll"); // Adjust if needed
            setFlaggedReviews(res.data.flaggedReviews || []);
        } catch (err) {
            console.error("Error fetching flagged reviews:", err);
        } finally {
            setLoading(false);
        }
    };

const handleAction = async (id, action) => {
    try {
        console.log(`Updating review status to "${action}" for review ID: ${id}`);

        // Optimistically update local state
        setFlaggedReviews(prev =>
            prev.map(r => r._id === id ? { ...r, status: action } : r)
        );

        // Step 1: Update status in your backend
        await API.patch(`/reviews/flagged/${id}`, { status: action });
        console.log("Status updated in backend.");

        // Step 2: If approved, send to Monday.com
        if (action === "approved") {
            const review = flaggedReviews.find(r => r._id === id);
            if (!review) {
                console.error("Review not found in local state for ID:", id);
                return;
            }

            const itemName = `Review #${review.reviewId}`;
            const columnValues = {
                text_mkmchghe: review.directoryName,
                text__1: review.companyName,
                text1: review.reviewer.displayName,
                numeric_mkrw4pd8: review.starRating,
                text15: review.comment,
            };

            console.log("Sending data to Monday.com...");
            console.log("Item Name:", itemName);
            console.log("Column Values:", columnValues);

            const mondayResponse = await createItemOnBoard({
                boardId: 2002376531,
                itemName,
                columnValues
            });

            console.log("Successfully sent to Monday.com:", mondayResponse);
        }

        // Step 3: Show confirmation
        setConfirmationMessage(
            action === "approved"
                ? "You approved the review. The company owner will be updated, and it was successfully sent to your Monday.com."
                : "You rejected the review. The company owner will be updated."
        );
        setShowConfirmation(true);

    } catch (err) {
        console.error(`❌ Error updating review status to "${action}" for review ID: ${id}`);
        console.error("Error message:", err.message);
        console.error("Full error:", err.response?.data || err);
    }
};






    return (
        <div className="p-4">
            <h2 className="text-2xl font-semibold mb-4">Flagged Reviews</h2>

            {loading ? (
                <div>Loading...</div>
            ) : flaggedReviews.length === 0 ? (
                <div>No flagged reviews found.</div>
            ) : (
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border rounded shadow-md">
                        <thead>
                            <tr className="bg-gray-100 text-left text-sm text-gray-700">
                               
                                <th className="p-3 border">Company</th>
                                <th className="p-3 border">Directory</th>
                                <th className="p-3 border">Reviewer</th>
                                <th className="p-3 border">Rating</th>
                                <th className="p-3 border">Comment</th>
                                <th className="p-3 border">Status</th>
                                <th className="p-3 border w-[200px]">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {flaggedReviews.map((review) => (
                                <tr key={review._id} className="text-sm hover:bg-gray-50">
                                   
                                    <td className="p-3 border">{review.companyName}</td>
                                    <td className="p-3 border">{review.directoryName}</td>
                                    <td className="p-3 border">{review.reviewer.displayName}</td>
                                    <td className="p-3 border">{review.starRating}</td>
                                    <td className="p-3 border">{review.comment}</td>
                                    <td className="p-3 border font-medium">{review.status}</td>
                                    <td className="p-3 border space-x-2">
                                        {review.status === "pending" ? (
                                            <>
                                                <button
                                                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                                                    onClick={() => handleAction(review._id, "approved")}
                                                >
                                                    Approve
                                                </button>
                                                <button
                                                    className="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                                                    onClick={() => handleAction(review._id, "disapproved")}
                                                >
                                                    Reject
                                                </button>
                                            </>
                                        ) : (
                                            <span className={`font-semibold ${review.status === "approved" ? "text-green-600" : "text-red-600"}`}>
                                                {review.status.charAt(0).toUpperCase() + review.status.slice(1)}
                                            </span>
                                        )}
                                    </td>

                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
            <ConfirmActionModal
                isOpen={showConfirmation}
                title="Action Completed"
                message={confirmationMessage}
                onConfirm={() => setShowConfirmation(false)}
                showCancelButton={false}
                confirmText="OK"
                confirmColor="blue"
            />

        </div>

    );
};

export default FlaggedReviewsTable;
